import Vue from 'vue';
import Vuetify from 'vuetify';
import App from './App.vue';
import cs from 'vuetify/es5/locale/cs';
import router from './router/index.js';
import apolloProvider from './apollo';
import 'vuetify/dist/vuetify.min.css';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

new Vue({
	vuetify : new Vuetify({
		theme: {
			options: {
				themeCache: {
					get: key => localStorage.getItem(key),
					set: (key, value) => localStorage.setItem(key, value),
				},
			},
		},
		lang: {
			locales: { cs },
			current: 'cs',
		},
	}),
	el: "#app",
	components: { App },
	template: "<App/>",
	router: router,
	apolloProvider: apolloProvider,
	store: Storage
});
